import React from 'react';
import { DateTimePicker } from 'react-widgets'

import {spacings, colors} from 'style';

var style = {
    inputWrapper: {
        color: colors.themeDarkerGrey,
        position: 'relative',
        padding: spacings.tiny,
    },
    inputLabel: {
        display: 'block',
        textAlign: 'left',
        paddingRight: spacings.tiny,
        paddingBottom: '4px',
    },
}



const ChallengeQuestionDateTime = ({challengeQuestion, value, index, onChangeDateTime}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}</label>
        <DateTimePicker
          onChange={datetime => onChangeDateTime('selectedChallenge.challengeQuestions.' + index + '.data', datetime)}
          value={value}
          step={5}
        />
    </div>
);


export default ChallengeQuestionDateTime;



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionDateTime.js